module.exports = __webpack_public_path__ + "img/1.d14dbde7.png";